// extracted by mini-css-extract-plugin
module.exports = {"main":"location-control_main__32_m8","relative":"location-control_relative__9NMcK","trashIcon":"location-control_trashIcon__1clAB"};